import { render, staticRenderFns } from "./OperaCreationWindow.vue?vue&type=template&id=51c273f5&scoped=true&"
import script from "./OperaCreationWindow.vue?vue&type=script&lang=js&"
export * from "./OperaCreationWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaCreationWindow.vue?vue&type=style&index=0&id=51c273f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c273f5",
  null
  
)

export default component.exports